import { render } from "./BundleCard.vue?vue&type=template&id=65a00396&scoped=true"
import script from "./BundleCard.vue?vue&type=script&lang=js"
export * from "./BundleCard.vue?vue&type=script&lang=js"

import "./BundleCard.vue?vue&type=style&index=0&id=65a00396&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a00396"]])

export default __exports__